/**
 * Warstwa API: PROCEDURY MODUŁU OBSŁUGI (polecenie właściciela 2026-09-30, E2).
 *
 * Trasy backendu (`TicketModulesController.Procedury.cs`, `api/ticket-modules`):
 *  • `GET {kod}/procedury`                — procedury modułu (kod modułu, kod strony wbudowanej albo alias itsm/tickets);
 *                                           serwer wpuszcza członka modułu, osobę w obsadzie przez procedurę,
 *                                           AdminAccessManage i PolitykiRedakcja — inaczej 403 ze zdaniem,
 *  • `GET moj-zakres`                     — „Twój zakres pracy”: moduły i tytuły zalogowanej osoby,
 *  • `GET procedury-do-wyboru`            — procedury, które obowiązują i są widoczne (PERM:AdminAccessManage),
 *  • `POST/PUT/DELETE {id}/procedury[/{linkId}]` — powiązanie modułu z procedurą (PERM:AdminAccessManage + PIN).
 *
 * Każda zmiana rozgłasza `ProceduryModuluZmiana` → most NotificationContext → zdarzenie okna `procedury-modulu-zmiana`.
 */
export const ZDARZENIE_PROCEDURY_MODULU = "procedury-modulu-zmiana";

export function attach(api) {
    return {
        getProceduryModulu: (kod) => api.get(`/ticket-modules/${encodeURIComponent(kod)}/procedury`),
        getMojZakresModulow: () => api.get("/ticket-modules/moj-zakres"),
        getProceduryDoWyboru: () => api.get("/ticket-modules/procedury-do-wyboru"),
        dodajProcedureModulu: (moduleId, dane) => api.post(`/ticket-modules/${moduleId}/procedury`, dane),
        zmienProcedureModulu: (moduleId, linkId, dane) => api.put(`/ticket-modules/${moduleId}/procedury/${linkId}`, dane),
        usunProcedureModulu: (moduleId, linkId) => api.delete(`/ticket-modules/${moduleId}/procedury/${linkId}`),
    };
}
